module.exports = __webpack_public_path__ + "img/album22_03.43e721d0.jpg";